import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "menu-wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_item = _resolveComponent("item")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_app_link = _resolveComponent("app-link")!
  const _component_sidebar_item = _resolveComponent("sidebar-item", true)!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!

  return (!_ctx.item.hidden)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.children || !_ctx.children.length)
          ? (_openBlock(), _createBlock(_component_app_link, {
              key: 0,
              to: _ctx.currentItem.frontEndUrl
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, {
                  index: _ctx.currentItem.frontEndUrl,
                  router: {
            name: _ctx.currentItem.frontEndUrl
          }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_item, {
                      icon: _ctx.currentItem.icon ? _ctx.currentItem.icon : '',
                      title: !_ctx.collapse ? _ctx.currentItem.resourceName : ''
                    }, null, 8, ["icon", "title"])
                  ]),
                  _: 1
                }, 8, ["index", "router"])
              ]),
              _: 1
            }, 8, ["to"]))
          : (_openBlock(), _createBlock(_component_el_sub_menu, {
              key: 1,
              ref: "subMenu",
              index: _ctx.currentItem.frontEndUrl,
              "popper-append-to-body": ""
            }, {
              title: _withCtx(() => [
                _createVNode(_component_item, {
                  icon: _ctx.currentItem.icon ? _ctx.currentItem.icon : '',
                  title: !_ctx.collapse ? _ctx.currentItem.resourceName : ''
                }, null, 8, ["icon", "title"])
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (child) => {
                  return (_openBlock(), _createBlock(_component_sidebar_item, {
                    key: child.resourceId,
                    "is-nest": true,
                    item: child,
                    class: "nest-menu"
                  }, null, 8, ["item"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["index"]))
      ]))
    : _createCommentVNode("", true)
}